import { Wallet, HandCoins, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { TRY } from "@/lib/format";
import { PAY_OPTIONS, PAY_LABEL } from "@/lib/pos";

const METHODS = PAY_OPTIONS.filter(([v]) => v !== "veresiye");
const num = (v) => { const s = String(v ?? "").trim(); return Number(s.includes(",") ? s.replace(/\./g, "").replace(",", ".") : s) || 0; };

export const blankPayAsk = (amount, method) => ({ choice: "", method: METHODS.some(([v]) => v === method) ? method : "nakit", amount: amount > 0 ? String(amount) : "" });
export const payAskAmount = (p) => Math.round(num(p.amount) * 100) / 100;
export const payAskError = (p, max) => {
  if (!p.choice) return "Ödeme alındı mı? — seçmeden fatura kesilemez";
  if (p.choice !== "received") return "";
  const a = payAskAmount(p);
  if (!(a > 0)) return "Alınan tutarı girin";
  if (a > max + 0.01) return `Tutar kalan bakiyeyi (${TRY(max)}) aşamaz`;
  return "";
};
export const payAskLabel = (p) => `${TRY(payAskAmount(p))} ${PAY_LABEL[p.method] || p.method}`;

// Fatura kesilirken ZORUNLU soru: ödeme alındı mı? Alındıysa yöntem + tutar → fatura kesilince tahsilat faturaya (ve cari hesaba) işlenir.
export function InvoicePaymentAsk({ value, onChange, max, contactTitle, fullOnly = false }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const who = contactTitle || "cari";
  const big = (on, tone) => cn("flex items-center justify-center gap-2 rounded-xl border-2 px-3 py-2.5 text-sm font-bold transition-colors active:scale-[0.99]",
    on ? (tone === "ok" ? "border-emerald-700 bg-emerald-700 text-white" : "border-amber-700 bg-amber-700 text-white") : "border-border bg-card text-foreground hover:bg-muted");
  return (
    <div className={cn("rounded-xl border-2 p-3 space-y-2.5", value.choice ? "border-border" : "border-red-400 bg-red-50 dark:bg-red-950")} data-testid="pay-ask">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] font-black uppercase tracking-wider text-foreground">Ödeme alındı mı? <span className="text-red-600">*</span></span>
        <span className="text-[11px] font-semibold text-muted-foreground tnum">Kalan {TRY(max)}</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button type="button" className={big(value.choice === "received", "ok")} onClick={() => set({ choice: "received" })} data-testid="pay-ask-received"><Wallet className="h-4 w-4" />Evet, alındı</button>
        <button type="button" className={big(value.choice === "open", "open")} onClick={() => set({ choice: "open" })} data-testid="pay-ask-open"><HandCoins className="h-4 w-4" />Hayır, alınmadı</button>
      </div>
      {value.choice === "received" && (
        <div className="space-y-2">
          <div className="grid grid-cols-3 gap-1.5">
            {METHODS.map(([v, l, Icon]) => {
              const on = value.method === v;
              return (
                <button key={v} type="button" onClick={() => set({ method: v })} data-testid={`pay-ask-method-${v}`}
                  className={cn("flex flex-col items-center gap-1 rounded-lg border-2 px-1.5 py-2 text-[11px] font-bold transition-colors", on ? "border-emerald-700 bg-emerald-700 text-white" : "border-border bg-card text-foreground hover:bg-muted")}>
                  <Icon className="h-4 w-4" /><span className="leading-tight text-center">{l}</span>{on && <Check className="h-3 w-3" />}
                </button>
              );
            })}
          </div>
          {!fullOnly && <div className="flex items-center gap-2">
            <span className="text-[11px] font-bold text-muted-foreground shrink-0">Alınan tutar</span>
            <Input inputMode="decimal" value={value.amount} onChange={(e) => set({ amount: e.target.value })} className="h-9 text-right font-bold tnum" data-testid="pay-ask-amount" />
            <button type="button" onClick={() => set({ amount: String(max) })} className="shrink-0 text-[11px] font-bold text-emerald-700 hover:underline" data-testid="pay-ask-full">Tamamı</button>
          </div>}
        </div>
      )}
      {value.choice && (
        <p className={cn("rounded-lg border px-2.5 py-1.5 text-[11px] leading-snug", value.choice === "received" ? "border-emerald-300 bg-emerald-50 text-emerald-950 dark:border-emerald-700 dark:bg-emerald-950 dark:text-emerald-50" : "border-amber-300 bg-amber-50 text-amber-950 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-50")} data-testid="pay-ask-hint">
          {value.choice === "received"
            ? <>Fatura kesilince <b>{payAskLabel(value)}</b> tahsilatı faturaya işlenir; <b>{who}</b> hesabında görünür.</>
            : <><b>{TRY(max)}</b> <b>{who}</b> hesabına borç olarak kalır; ödeme hatırlatmasına düşer.</>}
        </p>
      )}
    </div>
  );
}
